<app-floorplan-item-details
  [extent]="extent()"
  [isExtendable]="true"
  [floorplanItem]="floorplanItem"
  [imageUrl]="imageUrl"
  (toggleExtendedButtonClicked)="toggleExtendedButtonClicked.emit()"
>
  <div data-main>
    <app-floorplan-item-group [floorplanItem]="floorplanItem"></app-floorplan-item-group>
  </div>
  @if (extent() !== SidesheetExtent.None) {
    <div data-extended>
      @if (isTransmitterPlaceholder(floorplanItem)) {
        <div>
          <app-floorplan-item-detail-transmitter-form
            [transmitter]="getTransmitterPlaceholder(floorplanItem)"
          ></app-floorplan-item-detail-transmitter-form>
        </div>
      } @else if (isGasWarningCenterPlaceholder(floorplanItem)) {
        <div>
          <app-floorplan-gas-warning-center-detail-form
            [gasWarningCenter]="getGasWarningCenterPlaceholder(floorplanItem)"
          ></app-floorplan-gas-warning-center-detail-form>
        </div>
      } @else if (isFlameDetectorPlaceholder(floorplanItem)) {
        <div>
          <app-floorplan-flame-detector-detail-form
            [flameDetector]="getFlameDetectorPlaceholder(floorplanItem)"
          ></app-floorplan-flame-detector-detail-form>
        </div>
      } @else {
        <app-floorplan-custom-part-numbers [floorplanItem]="floorplanItem"></app-floorplan-custom-part-numbers>
      }
    </div>
  }
</app-floorplan-item-details>
